import { Injectable } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { DeckData } from "./deck.data";
import { UIData } from "./ui.data";

/**
 * Like the {@link EventBroker} but for requesting data instead of pushing it.
 * 
 * I think this is pretty neat, not sure exactly what the pattern is called.
 * But essentially when you have a disconnected component that wants data it
 * can emit a request event. Then if there are any subscribed data sources,
 * they will receive that request and provide the data in a callback.
 */
@Injectable({ providedIn: "root" })
export class DataBroker {
    public deck: DeckData = new DeckData();
    public ui: UIData = new UIData();
}